export enum ApiUrlVersionEnum {
  v1 = 'v1',
}
